module.exports = __webpack_public_path__ + "img/candidates-per-branch.0e92287.svg";